var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Box, Button, Link, Tab, Tabs, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FilterSelector } from '../components/FilterSelector';
import { colors } from '../styles/MuiTheme';
var externalLinkStyle = {
    color: colors.rsYellow,
    textDecorationColor: colors.rsYellow,
};
export var AppHeader = function () {
    var buildInfo = { gitSha: 'main' };
    try {
        buildInfo = require('../build-info.json');
    }
    catch (_a) {
        console.warn('Could not load build info, using default');
    }
    var location = useLocation();
    return (_jsxs(AppBar, __assign({ sx: {
            backgroundColor: colors.rsDarkBrown,
            padding: 1,
        }, position: "sticky" }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex' } }, { children: [_jsx(Typography, __assign({ variant: "h4", color: "primary" }, { children: "FilterScape.xyz" })), _jsxs(Tabs, __assign({ value: location.pathname === '/import'
                            ? '/'
                            : location.pathname }, { children: [_jsx(Tab, { label: "New filter", value: "/new-filter", to: "/new-filter", component: RouterLink }), _jsx(Tab, { label: "Customize", value: "/", to: "/", component: RouterLink }), _jsx(Tab, { label: "Help", value: "/help", to: "/help", component: RouterLink }), buildInfo.gitSha === 'main' && (_jsx(Tab, { label: "Debug", value: "/debug", to: "/debug", component: RouterLink }))] })), _jsx(Button, __assign({ color: "secondary" }, { children: _jsx(Link, __assign({ sx: externalLinkStyle, target: "_blank", href: "https://discord.gg/ESbA28wPnt" }, { children: "Join the Discord" })) })), _jsxs(Typography, __assign({ color: "primary", variant: "body2", sx: { marginLeft: 'auto' } }, { children: ["A customizer for the", ' ', _jsx(Link, __assign({ sx: externalLinkStyle, target: "_blank", href: "https://runelite.net/plugin-hub/show/loot-filters" }, { children: "Loot Filters plugin" }))] })), _jsxs(Typography, __assign({ sx: { marginLeft: 1 }, variant: "body2", color: "text.secondary" }, { children: ["version: ", buildInfo.gitSha.slice(0, 7)] }))] })), location.pathname === '/' && (_jsx(Box, __assign({ paddingTop: 1 }, { children: _jsx(FilterSelector, {}) })))] })));
};
